import * as utils from 'shared/utils'
import { down, up } from 'styled-breakpoints'
import router from 'next/router'
import styled from 'styled-components'
import Link from 'next/link'
import Page from 'shared/ui/Page'
import { Dict } from 'shared/types'
import Image from 'next/image'

const ASSETS_CDN = process.env.NEXT_PUBLIC_ASSETS_CDN

const backgrounds: Dict = {
  "tommy-cash":`${ASSETS_CDN}/print/20/0000.png`,
  "ilja-karilampi": `${ASSETS_CDN}/print/22/1110.png`,
  "nik-kosmas": `${ASSETS_CDN}/print/23/1312.png`,
  "katja-novitskova": `${ASSETS_CDN}/print/8/2110.png`
}

const Artists: React.FC = () => {
  
  return (
    <Page transparentHeader>
      <ArtistsContainer>
        {Object.values(utils.artists).map((artist: any, i) => (
          <Link key={artist.id} href={`/artists/${artist.id}`} passHref>
            <Artist onClick={() => router.push(`/artists/${artist.id}`)}>
              <ArtistBackground index={i} />
              <ArtistContent index={i} >
                <a>{artist.name}</a>
                {artist.description.replace(artist.name, '')}
              </ArtistContent>
              <ArtistImage>
                <Image
                  src={backgrounds[artist.id]}
                  layout="responsive"
                  width={2480}
                  height={3508}
                  sizes={`(min-width: 1000px) 50vw,100vw`}
                  quality={100}
                  priority
                />
              </ArtistImage>
            </Artist>
          </Link>
        ))}
      </ArtistsContainer>
    </Page>
  )
}

export default Artists

const ArtistsContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  grid-auto-rows: 1fr;

  a {
    text-decoration: none;
  }

  ${down('small')} {
    grid-template-columns: 1fr;
    grid-auto-rows: max-content;
  }
`

const ArtistContent = styled.div`
  position: relative;
  line-height: 1.45rem;
  pointer-events: none;

  a {
    font-weight: bold;
    text-decoration: none;
  }

  ${down('small')} {
    ${({ index = 0 }: { index: number }) => index === 0 && `
      margin-top: 4rem;
    `}
  }

  ${({ index = 0 }: { index: number }) => (index === 0 || index === 2) && `
    padding-right: 2.75rem;
  `}

  ${({ index = 0 }: { index: number }) => (index === 1 || index === 3) && `
    text-align: right;
    padding-left: 2.75rem;
  `}
`

const STAR_RADIUS = '50%'

const borderRadiuses = (radius = STAR_RADIUS) => (
  [
    `0 0 ${radius}`,
    `0 0 0 ${radius}`,
    `0 ${radius} 0 0`,
    `${radius} 0 0 0`
  ]
)

const ArtistBackground = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-radius: 0;
  
  &:hover {
    ${({ index = 0 }: { index: number }) => `
      border-radius: ${borderRadiuses()[index]};
    `}
  }

  transition: border-radius 0.5s ease-in-out;
  
  background: white;
  border: 1px solid black;

  ${up('medium')} {
    
    ${({ index = 0 }: { index: number }) => index < 2 && `
      border-top: 0;
      height: calc(100% + 1px);
    `}
    ${({ index = 0 }: { index: number }) => (index === 0 || index === 2) && `
      border-left: 0;
      width: calc(100% + 1px);
    `}
    ${({ index = 0 }: { index: number }) => (index >= 2) && `
      border-bottom: 0;
      height: calc(100% - 1px);
    `}
    ${({ index = 0 }: { index: number }) => (index === 1 || index === 3) && `
      border-right: 0;
      margin-left: -1px;
      width: 100%;
    `}
  }

  ${down('small')} {
    border-width: 0;
    border-bottom: 1px solid var(--color-black);
  }
`

const ArtistImage = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-radius: 0;
  z-index: -1;
`

const Artist = styled.a`
  display: block;
  position: relative;
  padding: var(--gutter);
  box-sizing: border-box;
  border-right: 1px solid var(--color-black);
  border-bottom: 1px solid var(--color-black);
  overflow: hidden;

  &:hover {
    color: black;
  }

  ${(props: { background?: string }) => props.background && `
    background-image: url('${props.background}');
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center center;
  `}

  &:nth-child(1) {
    padding-top: 6.5rem;
  }

  ${up('medium')} {
    &:nth-child(2) {
      padding-top: 6.5rem;
    }
  }

  &:nth-child(2n) {
    border-right: 0;
  }

  &:nth-last-of-type(-n+2) {
    border-bottom: 0;
  }

  ${down('small')} {
    border-width: 0;
    border-bottom: 1px solid var(--color-black);

    &:nth-last-of-type(-n+2) {
      border-bottom: 1px solid var(--color-black);
    }
  }
`
